import { GenIcon } from '../helpers/IconBase.es.js';

const RatingFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.1958 18.4749C12.0707 18.4217 11.9293 18.4217 11.8042 18.4749L6.58683 20.6947C6.23942 20.8425 5.8598 20.5667 5.89302 20.1906L6.39193 14.5426C6.40389 14.4072 6.36021 14.2728 6.27095 14.1703L2.5475 9.89418C2.29956 9.60945 2.44457 9.16318 2.81251 9.07856L8.33827 7.80772C8.47074 7.77725 8.58509 7.69417 8.655 7.5776L11.5712 2.715C11.7654 2.39121 12.2346 2.39121 12.4288 2.715L15.345 7.5776C15.4149 7.69417 15.5293 7.77725 15.6617 7.80772L21.1875 9.07856C21.5554 9.16318 21.7004 9.60945 21.4525 9.89419L17.729 14.1703C17.6398 14.2728 17.5961 14.4072 17.6081 14.5426L18.107 20.1906C18.1402 20.5667 17.7606 20.8425 17.4132 20.6947L12.1958 18.4749Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { RatingFilled };
